export default __webpack_public_path__ + "static/media/officialCN.dfce3f8d.jpg";